import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page bg-grey" }
const _hoisted_2 = {
  key: 0,
  class: "menu"
}
const _hoisted_3 = ["href", "title"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 0,
  style: {"color":"var(--color-supportive-1)","width":"auto"},
  class: "truncate"
}
const _hoisted_6 = { class: "row no-gutters" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "vertical-flow-header" }
const _hoisted_9 = { class: "row no-gutters" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = {
  key: 0,
  class: "page__content vertical-flow"
}
const _hoisted_12 = { class: "row no-gutters" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = {
  key: 0,
  class: "page__content vertical-app"
}
const _hoisted_15 = { class: "vertical-app vertical-flow" }
const _hoisted_16 = { class: "vertical-flow__form__step vertical-flow__form__step--header" }
const _hoisted_17 = { class: "receipt__content title-block" }
const _hoisted_18 = { class: "vertical-flow__form__step__title vertical-flow__form__step__title--initial" }
const _hoisted_19 = { class: "vertical-flow__form__step__text" }
const _hoisted_20 = { class: "header-sub-title" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "label" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "spacer",
  innerHTML: ' '
}, null, -1)
const _hoisted_24 = { class: "content" }
const _hoisted_25 = {
  key: 0,
  class: "header-sub-title__receipt"
}
const _hoisted_26 = { class: "vertical-flow__form__step vertical-flow__form__step--header" }
const _hoisted_27 = { class: "vertical-flow__form__step vertical-flow__form__step--validated vertical-flow__form__step__receipt" }
const _hoisted_28 = { class: "vertical-flow__form__step__title" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-flow__form__step__number" }, null, -1)
const _hoisted_30 = { class: "vertical-flow__form__step__text" }
const _hoisted_31 = { class: "no-subtext step step__title" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 0,
  class: "vertical-flow__form__step vertical-flow__form__step--header"
}
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = {
  key: 1,
  class: "row no-gutters"
}
const _hoisted_37 = { class: "col-12 mt-5" }
const _hoisted_38 = { class: "offer-load-error mt-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "Modal__errorIcon" }, null, -1)
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "row no-gutters" }
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = {
  key: 0,
  class: "page__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleModalComponent = _resolveComponent("ToggleModalComponent")!
  const _component_PageTitleComponent = _resolveComponent("PageTitleComponent")!
  const _component_UsabillaInPageComponent = _resolveComponent("UsabillaInPageComponent")!
  const _component_VerticalStepComponent = _resolveComponent("VerticalStepComponent")!
  const _component_ContactComponent = _resolveComponent("ContactComponent")!
  const _component_cookieFooter = _resolveComponent("cookieFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ToggleModalComponent),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.model)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("a", {
              href: _ctx.model?.frontendConfiguration?.headerReference?.logoUrl?.url,
              title: _ctx.domain.title
            }, [
              _createElementVNode("img", {
                class: "logo",
                src: _ctx.model?.frontendConfiguration?.headerReference?.logoImage?.url,
                alt: _ctx.model?.frontendConfiguration?.headerReference?.logoImage?.properties?.altText
              }, null, 8, _hoisted_4)
            ], 8, _hoisted_3),
            (_ctx.mockedDataLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Api failed -> Mock! "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.model)
              ? (_openBlock(), _createBlock(_component_PageTitleComponent, {
                  key: 0,
                  "main-title": _ctx.renderPage ? _ctx.headline : undefined,
                  "pre-title": " "
                }, null, 8, ["main-title"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_ctx.renderPage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.usabillaBlock)
                  ? (_openBlock(), _createBlock(_component_UsabillaInPageComponent, {
                      key: 0,
                      class: "mt-4 mb-3",
                      model: _ctx.usabillaBlock
                    }, null, 8, ["model"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.renderPage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.proposalIdLabel), 1),
                              _hoisted_23,
                              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.proposalId), 1)
                            ])
                          ]),
                          (_ctx.subtitle)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_25, _toDisplayString(_ctx.subtitle), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.allSignaturesDone
													? _ctx.model.productsHeadline
													: _ctx.model.productsHeadlineMissingSignature), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass([
									'receipt__content',
									{ 'receipt__content--maximizeWidth': _ctx.policy.maximizeWidth },
								])
                    }, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_VerticalStepComponent, { step: _ctx.policy }, null, 8, ["step"]),
                        _createElementVNode("div", {
                          innerHTML: 
											_ctx.allSignaturesDone ? _ctx.model.mainContent : _ctx.model.mainContentMissingSignature
										
                        }, null, 8, _hoisted_32)
                      ])
                    ], 2)
                  ]),
                  (_ctx.model.secondaryContent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", {
                          innerHTML: 
									_ctx.allSignaturesDone ? _ctx.model.secondaryContent : _ctx.model.secondaryContentMissingSignature
								
                        }, null, 8, _hoisted_34)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("a", {
                      class: "Button Button__primary mt-3",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep()))
                    }, _toDisplayString(_ctx.policy.buttonLabel), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.loadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", {
                  class: "error-box",
                  innerHTML: _ctx.loadError
                }, null, 8, _hoisted_40)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          ((_ctx.renderPage || _ctx.loadError) && _ctx.model?.contactBox?.items?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createVNode(_component_ContactComponent, {
                  class: _normalizeClass(['vertical-app vertical-flow contact receipt__contact', { contactHasError: _ctx.loadError }]),
                  model: _ctx.model.contactBox.items[0].content
                }, null, 8, ["class", "model"])
              ]))
            : _createCommentVNode("", true),
          (
						(_ctx.renderPage || _ctx.loadError) &&
						_ctx.model?.frontendConfiguration?.footerReference?.linkColumns[0]?.links?.length > 0
					)
            ? (_openBlock(), _createBlock(_component_cookieFooter, {
                key: 1,
                footerLinks: _ctx.model.frontendConfiguration.footerReference.linkColumns[0].links
              }, null, 8, ["footerLinks"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}